import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import IconButton from '@mui/material/IconButton'
import React, { useEffect, useState } from 'react'
import { MAX_PRODUCT_QTY } from '../../../../constants'

interface Props {
  quantity: number
  availableQuantity: number
  canZero?: boolean

  onChangeQuantity(quantity: number): void
}

// Pill-shaped stepper matching the quantity widget already used on Cart (CartlineQtyWidget).
const KitQuantityStepper: React.FC<Props> = ({ quantity, availableQuantity, canZero = false, onChangeQuantity }) => {
  const [localQty, setLocalQty] = useState<string>(quantity.toString())

  useEffect(() => {
    setLocalQty(quantity.toString())
  }, [quantity])

  const min = canZero ? 1 : 2
  const max = Math.min(availableQuantity, MAX_PRODUCT_QTY)

  const handleChangeQty = (qty: string) => {
    setLocalQty(qty)
    if (qty !== '' && +qty > 0 && +qty <= max) {
      onChangeQuantity(+qty)
    }
  }

  const handleBlur = event => {
    const qty = event.target.value
    if (qty !== '' && +qty > 0 && +qty <= max) {
      setLocalQty(qty)
      onChangeQuantity(+qty)
    } else if (qty !== '' && +qty > max) {
      setLocalQty(max.toString())
      onChangeQuantity(max)
    } else {
      setLocalQty((canZero ? 0 : 1).toString())
    }
  }

  return (
    <div className='flex items-center justify-center w-120 h-[36px] px-6 border border-solid border-gray-300 rounded-lg bg-white'>
      <IconButton
        size='small'
        sx={{ borderRadius: 0 }}
        disableRipple
        onClick={() => onChangeQuantity(quantity - 1)}
        disabled={quantity < min}
      >
        <RemoveIcon fontSize='inherit' style={{ width: 22, height: 22 }} />
      </IconButton>
      <span className='flex-1 appearance-none text-center'>
        <input
          className='max-w-full w-40 text-center border-0 bg-white'
          type='number'
          value={localQty}
          onChange={event => handleChangeQty(event.target.value)}
          onBlur={handleBlur}
        />
      </span>
      <IconButton
        size='small'
        sx={{ borderRadius: 0 }}
        disableRipple
        onClick={() => onChangeQuantity(quantity + 1)}
        disabled={quantity >= max}
      >
        <AddIcon fontSize='inherit' style={{ width: 22, height: 22 }} />
      </IconButton>
    </div>
  )
}

export default KitQuantityStepper
